/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type CaseManagementDtoComplexCaseStatus =
  (typeof CaseManagementDtoComplexCaseStatus)[keyof typeof CaseManagementDtoComplexCaseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CaseManagementDtoComplexCaseStatus = {
  COMPLEX: 'COMPLEX',
  NOT_COMPLEX: 'NOT_COMPLEX',
  UNKNOWN: 'UNKNOWN',
} as const;
